import React from "react";

import { isDev } from "@brexhq/shared/utils/env/isDevEnv";

import ArticleListModule from "./modules/ArticleList/ArticleList";
import GroupModule from "./modules/Group";
import LinkHeroModule from "./modules/LinkHero/LinkHero";
import LinkListModule from "./modules/LinkList";
import SocialLinksModule from "./modules/SocialLinks/SocialLinks";
import type { INavColumn } from "./types";

// FIXME: this is only going to be temporary for now. we should
// adjust this later to make the nav container accept
// "moduleRenderers" as a prop and then pass that down through
// context so that in next we can have dynamic imports.
const moduleMapper = {
  articleListNavModule: ArticleListModule,
  groupNavModule: GroupModule,
  linkHeroNavModule: LinkHeroModule,
  linkListNavModule: LinkListModule,
  socialLinksNavModule: SocialLinksModule,
};

interface Props {
  modules: INavColumn["modules"];
  span: number;
}

export default function ModuleRenderer({ modules, span }: Props) {
  if (!modules) {
    return null;
  }
  return (
    <>
      {modules.map(({ _key, _type, ...moduleProps }, i) => {
        let key = _key;

        if (!key) {
          key = i;
          if (isDev) {
            console.warn(
              `Missing _key for nav module "${_type}" at index ${i}`,
            );
          }
        }

        const Component: any = moduleMapper[_type];

        if (Component) {
          return <Component key={_key} {...moduleProps} span={span} />;
        }

        if (isDev) {
          return (
            <h1 key={key} style={{ color: "black" }}>
              No renderer for {_type}
            </h1>
          );
        }

        return null;
      })}
    </>
  );
}
